import ActionTypes from 'app/redux-boneyard/refresh/ActionTypes';
import reducer from 'app/redux-boneyard/refresh/reducer';

export default {
  reducers: {
    refresh: reducer,
  },
  actionTypes: ActionTypes,
};
